const endpoint = process.env.GRAPHCMS_ENDPOINT || "https://api-us-east-1.graphcms.com/v2/ckk4oc9vjwm3b01xs1n42durk/master";
const token = process.env.GRAPHCMS_TOKEN || "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImdjbXMtbWFpbi1wcm9kdWN0aW9uIn0.eyJ2ZXJzaW9uIjozLCJpYXQiOjE2MTExMDIxMDksImF1ZCI6WyJodHRwczovL2FwaS11cy1lYXN0LTEuZ3JhcGhjbXMuY29tL3YyL2NrazRvYzl2andtM2IwMXhzMW40MmR1cmsvbWFzdGVyIl0sImlzcyI6Imh0dHBzOi8vbWFuYWdlbWVudC5ncmFwaGNtcy5jb20vIiwic3ViIjoiNmZkODk4NTYtNzlkNi00OGJkLTkyNTQtY2I2OTBiNGQwYWQ1IiwianRpIjoiY2trNG9sanV4d3BqZzAxeHM4ZGh2M2o2ZSJ9.jBF93HHDjGHpK6yETlA-NZ7q6vGwr7GMDle_ysJemjLY8RKFCnMG6IuUm1OtxgJgRcF2nX4H0F1w22tzc28toWHIA15M5ZJSQIUydjHbv7lvAoaMNY0H8A-CzCfcRkmrbKIMXfvOxHIA00_ooXnpUOz-sTC1eTDo0F22r0rihSvuvTjneGaqtkYxcCyClIBcIR0ehyIMl_zu8XXPN-l6fm1hL2qzW8ZrQvg1nf2wJlAKO9D8hGyd7mO3tjTmPqTy4pflCvhmJdQ32bAm-f9-MTKmUUEINGzWCjk80bus0_tWTYKYDVBOyu6mIxv82aBVxlStYTqTmEAMgrIFq_DN2pPupZkv8dJpEut_N81I0iSykpgwgBdnN8Vb6evzNgdrf-vbH82_lPWeyynICDeRjU5ZiPoWoljGItwPULFOqZEK0pmLOwKmAs-6YsPJeEkBazAP59vDQjORUZQEMdYVqWXBVPseMx33n1D_rv-rX77pNckgiILo8YhAhBCp0bljqy4zIn5_IQOux81Z1b3N4WvWM_MMVVbMHd1Lw5j6-ph9qVK5iLJRXizs5XO743kpYM9azsJUOC-lcm8g0uaJxlclWSMlzv2VKkmk0nnu-QVdW6c8WVESEzk_wcUz8h2XZLyU3yq4140VweGwV7TmyDNDh8AZb_QSrh7TqVI3VSo"

import "isomorphic-fetch";

export const pageQuery = (slug) => {
    return `query postQuery {
    page(where: {slug: "${slug}"}) {
      id
      createdAt
      updatedAt
      title
      content {
        markdown
      }
    }
  }`
}

export async function invokeQuery(query) {
    return await fetch(`${endpoint}`, {
        method: "POST",
        headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query,
            operationName: "postQuery"
        })
    });
}
